// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-container[data-v-243beb27]{position:fixed;z-index:999999}", ""]);
// Exports
module.exports = exports;
